import { render } from "./EsqueceuSenhaView.vue?vue&type=template&id=400e0c3e&scoped=true"
import script from "./EsqueceuSenhaView.vue?vue&type=script&lang=js"
export * from "./EsqueceuSenhaView.vue?vue&type=script&lang=js"

import "./EsqueceuSenhaView.vue?vue&type=style&index=0&id=400e0c3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-400e0c3e"]])

export default __exports__